import BasicSelect from 'further-ui/components/BasicSelect';
import { Row } from 'further-ui/components/Layout';
import { CalendarDay } from 'further-ui/utils';
import { AccountingPeriodStatus } from 'further-types/lp/accounting-period';
import api from 'lib/trpcClient';
import { useLayoutContext } from 'contexts/LayoutContext';

type Props = {
  selectedDate: CalendarDay | null;
  onChange: (date: CalendarDay) => void;
};

const PcapDateSelector: React.FC<Props> = ({ selectedDate, onChange }) => {
  const { selectedVehicleId } = useLayoutContext();

  const [periods] = api.accountingPeriod.listPeriods.useSuspenseQuery({
    vehicleId: selectedVehicleId ?? '',
  });

  if (!periods.length) return null;

  const options = periods.map((period) => {
    const isClosed = period.status === AccountingPeriodStatus.Approved;
    return {
      value: period.periodEnd.toString(),
      label: `${period.periodEnd.toReadable(true)}${
        isClosed ? ' (Closed)' : ''
      }`,
    };
  });

  return (
    <Row spacing="sm" centered>
      <BasicSelect
        value={selectedDate?.toString() ?? ''}
        onChange={(value) => onChange(new CalendarDay(value))}
        options={options}
      />
    </Row>
  );
};

export default PcapDateSelector;
